import { takeLatest, put, call } from 'redux-saga/effects';
import { path, history, storage } from '@commons';
import { createPartnerWhiteLabel, updatePartnerWhiteLabel } from '../service';
import {
  CREATE_PARTNER_WHITE_LABEL,
  CREATE_PARTNER_WHITE_LABEL_PENDING,
  CREATE_PARTNER_WHITE_LABEL_SUCCESS,
  CREATE_PARTNER_WHITE_LABEL_FAILURE,
} from '@handler';
import { AlertSuccess, AlertError } from '@components/common/AlertToast';

function* sagaCreatePartnerWhiteLabel(action) {
  yield put({ type: CREATE_PARTNER_WHITE_LABEL_PENDING });

  try {
    let user = JSON.parse(storage.get(path.sessionUser));

    var newPartner = {
      ...action.data,
      "identificationCodeWhiteLabel": user.identificationCodeWhiteLabel,
    }

    if (action.data.id === undefined || action.data.id === null) {
      yield call(createPartnerWhiteLabel, newPartner);
    } else {
      yield call(updatePartnerWhiteLabel,
        {
          ...action.data,
          id: action.data.id
        }
      );
    }

    yield put({ type: CREATE_PARTNER_WHITE_LABEL_SUCCESS, registro: action.data });

    if (!action.isCadastroRapido) {
      history.push('/corporate/parceiros');
    }

    AlertSuccess('Registro salvo com sucesso!');
  } catch (error) {
    yield put({ type: CREATE_PARTNER_WHITE_LABEL_FAILURE, registro: action.data });
    AlertError('Falha ao salvar o registro! Tente novamente...');
  }
}

export default function* watchCreatePartnerWhiteLabel() {
  yield takeLatest(CREATE_PARTNER_WHITE_LABEL, sagaCreatePartnerWhiteLabel);
}
